import { IRichTextInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import { Link } from "gatsby";
import React from "react";
import { RTF } from "../elements/RTF";
import { Separator } from "../elements/Separator";
import { IVisual, Visual } from "../shared/Visual";
import { MainWidthClassName, SectionPaddingClassName } from "../styles";

export const BannerVideo: React.FC<{
  heading: string | null;
  visual?: IVisual;
  message?: IRichTextInformation;
  link?: string;
  linkTitle?: string | null;
}> = ({ heading, visual, message, link, linkTitle }) => {
  return (
    <section
      className={classNames(
        SectionPaddingClassName,
        "page-grid relative col-span-full gap-10",
      )}
    >
      <Separator className={classNames(MainWidthClassName, "my-0")} />
      {heading && (
        <h2 className="h2 lg:mb-110px col-span-4 col-start-2 mb-5 text-center text-hyacinth md:col-span-6 md:col-start-3 md:mb-60px lg:col-span-12 lg:col-start-3">
          {`/${heading}/`}
        </h2>
      )}
      {visual && (
        <Visual
          className="col-span-4 col-start-2 md:col-span-8 md:col-start-2 lg:col-span-12 lg:col-start-3"
          visual={visual}
        />
      )}
      <div className="col-span-4 col-start-2 md:col-span-5 md:col-start-5 lg:col-span-8 lg:col-start-7">
        {message && <RTF content={message} className="h4 mb-40px md:mb-60px" />}
        {link && (
          <Link
            to={`${link}`}
            className={classNames(
              "servicesButton inline-flex px-2 text-hyacinth",
            )}
            aria-label={`Go to page ${linkTitle ?? "??"}`}
          >
            {linkTitle?.toUpperCase()}
          </Link>
        )}
      </div>
    </section>
  );
};
